import fragmentShader from './wave.frag'
import vertexShader from './wave.vert'
import {
  DoubleSide,
  ShaderMaterialParameters,
  Color,
  Texture,
  Vector3
} from 'three'

const wave: ShaderMaterialParameters = {
  vertexShader,
  fragmentShader,
  uniforms: {
    uTime: { value: 0 },
    color: { value: new Color('#fff') },
    gradient: { value: new Texture() },
    gradientWidth: { value: 2 },
    positionOffset: { value: new Vector3(0, 0, 0) }
  },
  transparent: true,
  wireframe: true,
  side: DoubleSide
}

export default wave
